<div class="divide-y divide-gray-200 overflow-hidden mt-5 bg-white shadow sm:rounded-lg">

  <div class="px-4 pb-3.5 pt-4 sm:p-6 max-h-[32rem] overflow-y-auto overscroll-y-contain">

    <analytics-percent-ul [hoverModel]="hoverModel"></analytics-percent-ul>
  </div>
</div>

